(() => {
  const pageCache = new Map();

  const UNIT_RADIO_GROUPS = {
    occasion_units: ".sizechart_incm_occasion",
    Bridal_units: ".sizechart_incm_Bridal",
    dresses_units: ".sizechart_incm_dresses",
    FlowerGirl_units: ".sizechart_incm_FlowerGirl",
  };

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function initPageContent(root) {
    if (!root) return;

    const tabsRoot = root.querySelector(".jtabs2");
    if (tabsRoot) {
      const tabBar = tabsRoot.querySelector(".jtabs2-title");
      const tabPanels = tabsRoot.querySelectorAll(".jtabs2-content > div");

      tabBar?.addEventListener("click", (event) => {
        const tab = event.target.closest(".jtabs2-title > div");
        if (!tab || !tabBar.contains(tab)) return;

        const index = Array.from(tabBar.children).indexOf(tab);
        tabBar.querySelectorAll(":scope > div").forEach((el) => {
          el.classList.remove("on");
        });
        tabPanels.forEach((el) => el.classList.remove("on"));
        tab.classList.add("on");
        tabPanels[index]?.classList.add("on");
      });
    }

    const measureTitle = root.querySelector(".jmeasure .title");
    const measureContent = root.querySelector(".jmeasure .contetn");
    if (measureTitle && measureContent) {
      measureTitle.addEventListener("click", () => {
        measureTitle.classList.toggle("on");
        const isHidden =
          measureContent.style.display === "none" ||
          (measureContent.style.display === "" &&
            window.getComputedStyle(measureContent).display === "none");
        measureContent.style.display = isHidden ? "block" : "none";
      });
    }

    root.addEventListener("change", (event) => {
      const input = event.target;
      if (input.type !== "radio") return;

      const chartSelector = UNIT_RADIO_GROUPS[input.name];
      if (!chartSelector) return;

      const charts = root.querySelectorAll(chartSelector);
      charts.forEach((chart) => chart.classList.remove("on"));

      if (input.value === "inches" && charts[0]) {
        charts[0].classList.add("on");
      } else if (input.value === "centimeters" && charts[1]) {
        charts[1].classList.add("on");
      }
    });
  }

  async function fetchPage(handle) {
    if (pageCache.has(handle)) {
      return pageCache.get(handle);
    }

    const response = await fetch(`/pages/${encodeURIComponent(handle)}.json`, {
      headers: { Accept: "application/json" },
    });

    if (!response.ok) {
      throw new Error("Unable to load size chart.");
    }

    const data = await response.json();
    const page = data?.page;

    if (!page?.body_html) {
      throw new Error("Size chart content is unavailable.");
    }

    pageCache.set(handle, page);
    return page;
  }

  function buildMetafieldTable(rawValue, stripedRows) {
    const rows = String(rawValue || "")
      .replace(/\r\n/g, "\n")
      .split("\n")
      .filter(Boolean);

    if (!rows.length) return "";

    const tableClass = stripedRows
      ? "size-table size-table--striped"
      : "size-table";

    const tableRows = rows
      .map((row) => {
        const cells = row.split("|").map((cell) => {
          const cleanCell = cell.trim();
          const firstChar = cleanCell.charAt(0);

          if (firstChar === "#") {
            return `<th>${escapeHtml(cleanCell.slice(1).trim())}</th>`;
          }

          return `<td>${escapeHtml(cleanCell)}</td>`;
        });

        return `<tr>${cells.join("")}</tr>`;
      })
      .join("");

    return `<div class="size-table__wrapper"><table class="${tableClass}">${tableRows}</table></div>`;
  }

  function renderLoadingPlaceholder() {
    const rows = Array.from(
      { length: 5 },
      () => '<span class="size-guide-lazy__skeleton-line"></span>',
    ).join("");

    return `
      <div class="size-guide-lazy__placeholder" aria-hidden="true">
        <span class="size-guide-lazy__skeleton-block size-guide-lazy__skeleton-block--title"></span>
        <span class="size-guide-lazy__skeleton-block size-guide-lazy__skeleton-block--short"></span>
        <div class="size-guide-lazy__skeleton-lines">
          ${rows}
        </div>
      </div>
    `;
  }

  function setBodyLoading(body, isLoading) {
    if (!body) return;

    if (isLoading) {
      body.setAttribute("aria-busy", "true");
      body.innerHTML = renderLoadingPlaceholder();
      return;
    }

    body.removeAttribute("aria-busy");
  }

  function getMetafieldValue(modal) {
    const scriptId = modal.dataset.sizeGuideMetafieldId || modal.id;
    const scriptNode = document.querySelector(
      `[data-size-guide-metafield="${scriptId}"]`,
    );
    if (!scriptNode) return "";

    try {
      return JSON.parse(scriptNode.textContent);
    } catch (error) {
      console.error("Size guide metafield parse failed:", error);
      return "";
    }
  }

  async function loadModalContent(modal, { showLoading = true } = {}) {
    const body = modal.querySelector("[data-size-guide-body]");
    if (!body) return;

    const handle = modal.dataset.sizeGuideHandle;
    const stripedRows = modal.dataset.sizeGuideStriped === "true";
    const metafieldValue = getMetafieldValue(modal);

    if (showLoading) {
      setBodyLoading(body, true);
    }

    const parts = [];

    if (metafieldValue) {
      parts.push(buildMetafieldTable(metafieldValue, stripedRows));
    }

    if (handle) {
      const page = await fetchPage(handle);
      parts.push(page.body_html);
    }

    if (!parts.length) {
      throw new Error("Size chart content is unavailable.");
    }

    body.innerHTML = parts.join("");
    initPageContent(body);
    modal.dataset.sizeGuideLoaded = "true";
  }

  function patchModal(modal) {
    if (modal.dataset.sizeGuidePatched === "true") return;
    if (!modal.dataset.sizeGuideHandle && !modal.dataset.sizeGuideMetafieldId) {
      return;
    }

    const originalShow = modal.show.bind(modal);

    modal.show = async function showWithLazySizeGuide(opener) {
      const body = modal.querySelector("[data-size-guide-body]");

      if (!modal.dataset.sizeGuideLoaded) {
        setBodyLoading(body, true);

        originalShow(opener);

        try {
          await loadModalContent(modal, { showLoading: false });
        } catch (error) {
          if (body) {
            body.innerHTML = `<p class="size-guide-lazy__error">${escapeHtml(
              error.message || "Unable to load size chart.",
            )}</p>`;
          }
        }

        return;
      }

      originalShow(opener);
    };

    modal.dataset.sizeGuidePatched = "true";
  }

  function init() {
    document
      .querySelectorAll("modal-dialog[data-size-guide-handle]")
      .forEach(patchModal);

    document
      .querySelectorAll("modal-dialog[data-size-guide-metafield-id]")
      .forEach(patchModal);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
